import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

// For Datadog - Changing environment from development, staging, production to dev, test, prod
const envMapping: Record<string, string> = {
    staging: 'staging',
    production: 'prod',
};

export const datadogConfig = {
    trackResources: false,
    trackLongTasks: true,
    trackUserInteractions: false,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask',
} as const;

export const datadogSetup = () => {
    const datadog_node_env = window.REACT_APP_NODE_ENV.trim();
    const datadog_env = envMapping[datadog_node_env] || datadog_node_env;

    if (['production', 'staging'].includes(window.REACT_APP_NODE_ENV)) {
        datadogRum.init({
            applicationId: 'aa8f1b6a-1439-4c8b-84f8-31b283f9a6c1',
            clientToken: 'pubffad395f4109e62c48a8d598a1102839',
            site: 'datadoghq.eu',
            service: 'partner-web',
            env: datadog_env,
            version: (process.env.REACT_APP_RELEASE_VERSION || 'unknown').trim(),
            ...datadogConfig,
        });

        datadogLogs.init({
            clientToken: 'pub7bb74e5a37a916d74509970a57bacb56',
            site: 'datadoghq.eu',
            service: 'partner-web',
            env: datadog_env,
            version: (process.env.REACT_APP_RELEASE_VERSION || 'unknown').trim(),
            sessionSampleRate: 100,
            forwardErrorsToLogs: true,
        });
    }
};
